import { cn } from "~/util/cn";

export const ChatMessageUserAttachment: React.FC<{
  base64: string;
  className?: string;
}> = ({ base64, className }) => {
  return (
    <div className={cn("flex flex-col items-start gap-2 py-2", className)}>
      <img
        src={base64}
        alt="User attachment"
        className="w-full max-w-xs rounded-lg shadow-md"
      />
    </div>
  );
};
